import React, { Component } from 'react';
import { Container, Table } from 'semantic-ui-react';
import axios from 'axios';
import { PtSelect, PtDateInput, PtInputConditionTab } from '../../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../../DropdownLib';
import config from '../../../../config';

export default class Condition extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.conditionModel.pavementcondition

    }

    render() {
        const { typeOptions/*,
            bridgeTypeOptions,
            rehabTypeOptions,
            maintTypeOptions,
            safetyTypeOptions,
            emergencyTypeOptions,
            projStatusOptions*/ } = DropdownLib.getDropdowns().CP_ProjectInfo;

        const { RQITypeOptions, SRTypeOptions, RUTTypeOptions } = DropdownLib.getDropdowns().CSF_Condition;
        /* The below PlannedProjectTypeOptions Gets the values from database using DropdownLib.js and helps to populate 
          dropdowns in Edit mode and the Edit button is on main-menu.js 
          Date: 07/12/2019 
         Author: Souradip Roy */
        const { PlannedProjectSurfaceTypeOptions } = DropdownLib.getDropdowns().PlannedProjectSurface;

        return (

            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Table compact="very">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell  >RQI-Ride</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="RQI" placeholder="Not Available" disabled value={this.state.RQI == null ? "Not Available" : this.state.RQI}
                                /></Table.Cell>
                                <Table.Cell ><PtSelect options={RQITypeOptions}
                                    onChange={this.onChangeSRnRqiDropdown} disabled={this.props.disabled} name="RQIOver" defaultVal={this.state.RQIOver} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >SR-Condition</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="SR" placeholder="Not Available" disabled value={this.state.SR == null ? "Not Available" : this.state.SR}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtSelect options={SRTypeOptions}
                                    onChange={this.onChangeSRnRqiDropdown} disabled={this.props.disabled} defaultVal={this.state.SROver} name="SROver" /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell >PQI-Pvmt Quality Index</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="PQI" placeholder="Not Available" disabled value={this.state.PQI == null ? "Not Available" : this.state.PQI}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab disabled whichInput="secondttb" inputType="number" name="PQIOver" placeholder="override" value={this.state.PQIOver == null ? '' : this.state.PQIOver}
                                    onChange={this.onInputChange} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell >IRI</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" placeholder="Not Available" name="IRI" disabled value={this.state.IRI == null ? "Not Available" : this.state.IRI}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" disabled={this.props.disabled} inputType="numberUnder300" name="IRIOver" value={this.state.IRIOver == null || this.state.IRIOver === 0 ? "" : this.state.IRIOver} placeholder="override"
                                    onChange={this.onInputChange} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >PCI</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" placeholder="Not Available" name="PCI" disabled value={this.state.PCI == null ? "Not Available" : this.state.PCI}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" placeholder="override" disabled={this.props.disabled} inputType="numberUnder100" name="PCIOver" value={this.state.PCIOver == null ? "" : this.state.PCIOver}
                                    onChange={this.onInputChange} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >RUT</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" placeholder="Not Available" name="RUT" disabled value={this.state.RUT === null ? "Not Available" : this.state.RUT}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtSelect options={RUTTypeOptions}
                                    onChange={this.onChangeDropdown} name="RUTOver" disabled={this.props.disabled} defaultVal={this.state.RUTOver} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >Date Collected</Table.Cell>
                            </Table.Row>
                            <Table.Row>

                                <Table.Cell ><PtInputConditionTab placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="PavementCollectedDate" disabled
                                    value={this.state.PavementCollectedDate == null ? 'Not Available' : this.getDate(this.state.PavementCollectedDate)}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtDateInput whichInput="secondttb" disabled={this.props.disabled} inputType="hwy" name="PavementCollectedDateOver" placeholder="Override"
                                    value={this.state.PavementCollectedDateOver == null ? '' : new Date(this.getDate(this.state.PavementCollectedDateOver)).toLocaleDateString('en-US', {
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                    })}
                                    onChange={(date) => { this.onChangeDate(date, "PavementCollectedDateOver"); }} /></Table.Cell>
                            </Table.Row>

                            {/* Planeed Project Section Starts */}
                            {/* Date: 07/09/2019 Author: Souradip Roy */}
                            <Table.Row>
                                <Table.Cell>Planned Project Type</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="PlannedProjType" disabled value={this.state.PlannedProjType === 0 || null ? "Not Available" : this.state.PlannedProjType}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtSelect options={typeOptions.slice(0, 5)}
                                    onChange={this.onChangeDropdown} disabled={this.props.disabled} defaultVal={this.state.PlannedProjTypeOver} name="PlannedProjTypeOver" /></Table.Cell>
                            </Table.Row>

                            {/* Date: 07/09/2019 Author: Souradip Roy */}
                            <Table.Row>
                                <Table.Cell>Planned Project Surface</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="PlannedProjectSurfaceType" disabled value={this.state.PlannedProjectSurfaceType == null || 0 ? "Not Available" : this.state.PlannedProjectSurfaceType}
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtSelect options={PlannedProjectSurfaceTypeOptions}
                                    onChange={this.onChangeDropdown} disabled={this.props.disabled} defaultVal={this.state.PlannedProjectSurfaceOver} name="PlannedProjectSurfaceOver" /></Table.Cell>
                            </Table.Row>

                            {/* Date: 07/09/2019 Author: Souradip Roy */}
                            <Table.Row>
                                <Table.Cell>Planned Project Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="<year></year>" name="PlannedProjYear" disabled value={this.state.PlannedProjYear == null || 0 ? "Not Available" : this.state.PlannedProjYear} placeholder="Year"
                                    onChange={this.onInputChange} /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" disabled={this.props.disabled} inputType="year" name="PlannedProjYearOver" value={this.state.PlannedProjYearOver} placeholder="Year"
                                    onChange={this.onInputChange} /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </ScrollArea>
            </Container>
        );
    }

    getDate(dateValue) {
        const newDate = new Date(dateValue)
        const showDate = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000)
        return `${showDate.getFullYear()}-${('0'+(showDate.getMonth() + 1)).slice(-2)}-${('0'+showDate.getDate()).slice(-2)}`
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();

        this.setState({ [name]: value === '' ? null : value }, () => { console.log(this.state.PCIOver) });
    }

    onChangeSRnRqiDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            const { RQITypeOptions, SRTypeOptions, } = DropdownLib.getDropdowns().CSF_Condition;

            this.setState({ PQIOver: (this.state.SROver !== 0 && this.state.RQIOver !== 0 && parseFloat(SRTypeOptions[this.state.SROver].label) && parseFloat(RQITypeOptions[this.state.RQIOver].label)) ?
                 Math.sqrt(SRTypeOptions[this.state.SROver].label * RQITypeOptions[this.state.RQIOver].label).toFixed(2) : null });
        });
    }

    onChangeDropdown = (e) => {

        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ [name]: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
            console.log(`${name} ${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} i am here`);
        }

        else {
            this.setState({ [name]: null });
            date &&
            console.log(`${name} ${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} i am here`);
        }

    }

    /* This Function helps to get the data from the Condition Table in the database and populate the values based on the Route chosen  */
    /* Date: 07/11/2019 */
    fetchConditionData() {
        let datecollected
        let datecollectedover
        axios.get(`${config.server}\\getConditionData\\${this.props.conditionModel.route.id}`)
            .then((res) => {
                try {
                    if (res.data.result[0].DateCollected !== null) {
                        datecollected = res.data.result[0].DateCollected.slice(0, 10);
                    }
                    else {
                        datecollected = null;
                    }
                    if (res.data.result[0].DateCollectedOver !== null) {

                        datecollectedover = res.data.result[0].DateCollectedOver.slice(0, 10);
                    }
                    else {
                        datecollectedover = null;
                    }

                    this.setState({
                        RQI: res.data.result[0].RQI ? Math.round(res.data.result[0].RQI * 100) / 100 : null,
                        RQIOver: Math.round(res.data.result[0].RQIOver * 100) / 100,
                        SR: res.data.result[0].SR ? Math.round(res.data.result[0].SR * 100) / 100 : null,
                        SROver: Math.round(res.data.result[0].SROver * 100) / 100,
                        PQI: res.data.result[0].PQI ? Math.round(res.data.result[0].PQI * 100) / 100 : null,
                        PQIOver: res.data.result[0].PQIOver ? Math.round(res.data.result[0].PQIOver * 100) / 100 : null,
                        IRI: res.data.result[0].IRI ? Math.round(res.data.result[0].IRI * 100) / 100 : null,
                        IRIOver: res.data.result[0].IRIOver ? Math.round(res.data.result[0].IRIOver * 100) / 100 : null,
                        PCI: res.data.result[0].PCI ? Math.round(res.data.result[0].PCI * 100) / 100 : null,
                        PCIOver: res.data.result[0].PCIOver ? Math.round(res.data.result[0].PCIOver * 100) / 100 : null,
                        RUT: res.data.result[0].RUT ? Math.round(res.data.result[0].RUT * 100) / 100 : null,
                        RUTOver: Math.round(res.data.result[0].RUTOver * 100) / 100,
                        PavementCollectedDate: datecollected,
                        PavementCollectedDateOver: datecollectedover
                    });
                }
                catch (e) {
                    console.log(e)
                    alert("Woops, There doesn't appear to be any Performance data for this route")
                }
            });
    }

    /* Planned Project API Consumption Starts 
     This Function is to use the dbo.MappedConsplanningAndConshistory table to get the values of Planned Project Section in the condition tab under construction history.
     Date: 07/08/2019
     Author: Souradip Roy */
    getplannedproject() {
        let PlannedProjectSurface;
        let PlannedProjectType;
        let PlannedProjectYear;
        let PlannedProjectYearOver;
        let PlannedProjectTypeOver;
        let PlannedProjectSurfaceOver;
        fetch(`${config.server}/get_plannedprojectvalue/` + this.props.conditionModel.route.id)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                for (let i = 0; i < data.length; i++) {
                    PlannedProjectSurface = data[i]['OptionValue'];
                    PlannedProjectSurfaceOver = data[i]['PlannedProjectSurfaceTypeOver'];
                    var tempPlannedProjectType = data[i]['PlannedProjectType'];
                    PlannedProjectYear = data[i]['PlannedProjYear'];
                    PlannedProjectYearOver = data[i]['PlannedProjYearOver'];
                    PlannedProjectTypeOver = data[i]['PlannedProjectTypeOver'];
                }

                this.setState({
                    PlannedProjectSurfaceType: PlannedProjectSurface, PlannedProjectSurfaceOver: PlannedProjectSurfaceOver,
                    PlannedProjYear: PlannedProjectYear, PlannedProjYearOver: PlannedProjectYearOver, PlannedProjType: tempPlannedProjectType, PlannedProjTypeOver: PlannedProjectTypeOver
                });

                if (data) {
                    fetch(`${config.server}/dropdown/`).then(response => response.json()).then(dataone => {
                        for (let i = 0; i < dataone.length; i++) {
                            if (tempPlannedProjectType === dataone[i]['OptionKey'] && dataone[i]['OptionName'] === 'lpTypeOptions') {
                                PlannedProjectType = dataone[i]['OptionValue'];
                                this.setState({
                                     PlannedProjType: PlannedProjectType
                                });
                            }
                        }

                    })
                }

            })
    }
    /* Planned Project API Consumption Ends */

    componentDidMount() {

        this.fetchConditionData();
        this.getplannedproject();
        this.state = this.props.conditionModel.pavementcondition
    }
    componentDidUpdate() {
        this.props.conditionModel.pavementcondition = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/forecasting/condition.js